//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Features.js";
let d=[[[0,"AngleTolerance",1,0],[0,"CreateAssociativeMirror",1,0],[0,"DistanceTolerance",1,0],[0,"OrientationAngleRule",1,0]],[[[],"CreatePlaneForList",{R_:{planeListBuilder:"Features.ShipDesign.PlaneListBuilder"}},0,0]],[]];
SPLM.Features.ShipDesign.FeatureParmsBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.FeatureParmsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.FeatureParmsBuilder.OrientationAngleRuleTypes = Object.freeze({
    "RightHand" : "RightHand", "ShipOrientation" : "ShipOrientation"});

export default SPLM;